const metersFormatter = new Intl.NumberFormat("pt-BR", {
  maximumFractionDigits: 0,
});

export const formatMeters = (value) =>
  `${metersFormatter.format(Number(value || 0))} m`;
